import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { TradingPhotoCardType } from '../types/TradingPhotoCardType';

interface SelectedTradingCardsState {
  selectedPhotoCards: TradingPhotoCardType[];
  addPhotoCard: (card: TradingPhotoCardType) => void;
  removePhotoCard: (cardId: string) => void;
  clearPhotoCards: () => void;
  setSelectedPhotoCards: (cards: TradingPhotoCardType[]) => void;
}

export const useSelectedTradingCardsStore = create<SelectedTradingCardsState>()(
  persist(
    (set) => ({
      selectedPhotoCards: [],
      addPhotoCard: (card) =>
        set((state) => ({
          selectedPhotoCards: [...state.selectedPhotoCards, card]
        })),
      removePhotoCard: (cardId) =>
        set((state) => ({
          selectedPhotoCards: state.selectedPhotoCards.filter(
            (c) => c.tradingPhotoCardId !== cardId
          )
        })),
      clearPhotoCards: () => set({ selectedPhotoCards: [] }),
      setSelectedPhotoCards: (cards) => set({ selectedPhotoCards: cards })
    }),
    {
      name: 'selected-trading-cards',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);
